<template>
    <div class="app">
      <Header ref="header" ></Header>
      <div class="banner">
        <div class="banner-main">
            支持绑定自有域名生成短链接
          <p>域名可直接跳转，支持10万条短链接，专人专用，防封稳定</p>
          <button  @click="$router.push('/tabs/buyDomain')" class="btn-003" style="margin-top:30px;">
            快速创建
          </button>
        </div>
      </div>
      <div style="padding-bottom: 20px;" class="zs_gezi_bg">
        <div class="mid" >

            <div class=" ">
                <div class="exclu-list clearfix">
                  <div class="exclu-item" style="background-color:rgba(71,112,243,0.7);">
                    <div class="m">域名直接跳转</div>
                    <div class="r">支持域名首页直接跳转，最短的短网址,比如输入45d.cn即跳转到您的链接</div>
                  </div>

                    <div class="exclu-item" style="background-color:rgba(60,204,26,0.7);">
                        <div class="m">自有域名</div>
                        <div class="r">支持自主绑定腾讯/阿里/华为云的域名</div>
                    </div>
                  <div class="exclu-item" style="background: rgba(44,223,239,0.7);">
                    <div class="m">转换条数10万</div>
                    <div class="r">自己的域名，链接随便转，转换条数可达到10万</div>
                  </div>
                    <div class="exclu-item" style="background-color:rgba(81,148,232,0.7);">
                        <div class="m">专属CDN加速</div>
                        <div class="r">加速您每一条短网址，延迟少，不拥堵</div>
                    </div>
                    <div class="exclu-item" style="background-color:rgba(71,164,243,0.7);">
                        <div class="m">高并发支持</div>
                        <div class="r">十万人同时点击，也能快速打开</div>
                    </div>

                  <div class="exclu-item" style="background-color:rgba(14,184,134,0.7);">
                    <div class="m">独立服务器</div>
                    <div class="r">拥有独享服务器，专门处理您的短网址链接跳转</div>
                  </div>
                    <div class="exclu-item" style="background-color:rgba(60,204,26,0.7);">
                        <div class="m">专人专用</div>
                        <div class="r">免收其他用户链接影响，高级订制</div>
                    </div>
                    <div class="exclu-item" style="background-color:rgba(184,199,55,0.6);">
                        <div class="m">客服支持</div>
                        <div class="r">7*24小时客服在线支持</div>
                    </div>

                </div>
            </div>
        </div>
      </div>
      <div class="mid" style="margin-top: 50px;">
        <div class="title2" style="margin-bottom: 50px;">直接购买官方专属短域名/满足个性化需求--省心省事<br>
          <div class="box mt10">

            <div class="fs16 gray">什么是自有域名？您在华为、腾讯、阿里云或者别处注册的域名，支持绑定过来，自有域名购买的是绑定数量</div>
            <div class="fs16 red mt10">购买我司专属短域名后请尽快发送域名过户信息给客服或联系客服，严禁用于违法违规，违规导致的所有后果均由您承担</div>

            <div class="exs_d1">
              <a @click="$router.push('/tabs/buyDomain')"   v-for="(item,index) in domainList" :key="item.id" :label="index" v-if="index<24">

                    <span v-if="item.bind_domains>0">自有域名</span>
                    <span v-if="item.bind_domains==0" >{{item.domain}}</span>
                    <span class="price" style="color:#f76a1a;font-size:12px;">￥{{item.price}}</span>
                    <span class="tips33" v-if="item.mark" style="color:#fff;font-size:12px;font-weight: 200; float:right;display: inline-block;padding:4px 8px; border-radius: 4px; background:#00c800;">{{item.mark}}</span>
              </a>
              <a @click="$router.push('/tabs/buyDomain')"  >
                <span >+ 更多域名/自有域名绑定</span>
              </a>

            </div>

          </div>
        </div>
      </div>

        <div class="mid" style="margin-top: 100px;: 50px;">
          <div class="title2" style="margin-bottom: 50px;">企业/个人自有域名绑定<br>
            如何使用企业域名生成短链接进行推广？只需两步</div>

          <div class="clearfix sm2">
            <img src="../../assets/images/zs03.png" width="500" style="float: left;">
            <div class="sm22">
              <div class="title33">第一步：购买专属服务</div>

              登录ttdwz.cc。依次点击“专属域名管理”>“购买专属域名”>“选择自有域名””>“填写你的域名”>“付款” <br>
              输入待绑定的域名，如：45kk.cn
              也可以为域名的二级域名，如：m.45kk.cn
            </div>

          </div>
          <div class="clearfix sm2">
            <img src="../../assets/images/zs02.png" width="500" style="float: left;">
            <div class="sm22">
              <div class="title33">第一步：配置与解析</div>

              登录域名管理平台（如阿里云、腾讯云等）对 待绑定域名进行解析。
              如待绑定域名为 xxx.cn，则记录类型为cname，主机记录为@，记录值为：xxx.cn.host.ttdwz.cc
            </div>

          </div>



        </div>

      <div class="mid" style="margin-top: 100px;: 50px;">
        <div class="title2" style="margin-bottom: 50px;">使用场景</div>

        <div class="use-scene">
        <ul class="use-scene-list d-flex justify-content-between align-items-center clearfix">
          <li>
            <img class="use-scene-img" src="../../assets/images/zs/use-scene-1.png">
            <h5 class="use-scene-item-title">短信营销</h5>
            <p class="use-scene-item-desc">解决短信中网址过长，推广成本高的问题；绑定企业域名推广，不仅可以增加品牌曝光，还可以提高短链打开率</p>
          </li>
          <li style="float: right;">
            <img class="use-scene-img" src="../../assets/images/zs/use-scene-2.png">
            <h5 class="use-scene-item-title">社群运营</h5>
            <p class="use-scene-item-desc">在社群内推广时，长网址被质疑不安全；推广效果差强人意，绑定企业域名推广，提高用户信任度，转化效果也会随之翻倍</p>
          </li>
        </ul>
        </div>
      </div>
      <section class="enterprise-domain-about">
        <div class="section-container">
          <p class="about-desc">绑定企业域名进行推广，不仅可以提高品牌曝光率，还可以打消用户疑虑</p>
          <h4 class="about-title">提高链接的打开率，推广效果翻N倍</h4>
          <a @click="$router.push('/tabs/buyDomain')" class="about-use-btn primary-btn">立即体验</a>
        </div>
      </section>
      <div class="mid">
      <section class="why-use">
        <div class="section-container">
          <h3 class="why-use-title">为什么使用企业域名推广效果好？</h3>
          <ul class="why-use-list d-flex justify-content-between align-items-center clearfix">
            <li>
              <img src="../../assets/images/zs/enterprise-domain-why-icon-1.png">
              <h5>安全性更高，连通性更好</h5>
              <p>使用企业或个人的域名网络连通性更好，不会因他人的违规造成封禁，也不会因共享域名影响域名的全国连通性，安全性更高</p>
            </li>
            <li>
              <img src="../../assets/images/zs/enterprise-domain-why-icon-2.png">
              <h5>强化域名品牌影响力</h5>
              <p>使用企业域名进行推广，可以强化域名品牌影响力，提升用户信任度，从而提高推广链接打开率和推广转化率，推广转化效果更好</p>
            </li>
            <li>
              <img src="../../assets/images/zs/enterprise-domain-why-icon-3.png">
              <h5>企业自己的短链接系统</h5>
              <p>不需开发和运营团队，2分钟简单配置就可以拥有一套自己的短链接系统</p>
            </li>
          </ul>
        </div>
      </section>
      </div>

        <div class="footer">Copyright &copy; 2018-2019  版权所有</div>
    </div>
</template>

<script>
import Header from "../header";
export default {
  name: "ExlcusiveDomain",
  data() {
    return {
      url:"",
      isVip: false,
      isGuest: true,
      domainList: [],
      user_info: {}
    }
  },
  mounted() {
    const token = this.$storeLocal.get('token');
    const user_info = this.$storeLocal.get('userInfo');
    const times = Date.parse(new Date())/1000;

    if (token !== null && token !== '' && token !== undefined) {
      if (user_info.expire_date > times){
        this.isVip = true;
      }
      this.isGuest = false;
      this.user_info = user_info;
    }
    setTimeout(this.getDomainList,200);

  },
  methods:{
      async getDomainList() {
        const {ret,data} = await this.$api.exclusive.getList();
        if (ret === 1000){
          this.domainList = data.list;
          if (data.list.length > 0){
            this.selDomainChange(0);
          }
        }
      },
      selDomainChange(val) {
        const now = new Date().setFullYear(new Date().getFullYear()+1);
        const sel = this.domainList[val];
        this.selDomain = sel.domain;
        this.selDomainID = sel.id;
        this.dmiPrice = sel.price;
        this.expireDate = now;
      }
  },

  components: {
    Header

  },

}
</script>

<style scoped>
    .app{
        height: auto;
        background-color: #f5f5f5;
    }
    .banner{background:#057BD0;color:#fff;height:260px;}
    .banner-main{width:1200px;margin:0px auto;text-align: center;font-size: 40px;
    padding-top:50px;
    }
    .banner-main p{font-size:16px;color:#fff;padding-top:20px;}

    .banner .btn-003{width:120px;height:52px;text-align: center;line-height: 52px;border-radius: 5px;--tw-bg-opacity: 1;
      background-color: rgba(255,255,255,var(--tw-bg-opacity));font-size: 20px;color:#057BD0;}

    .mid{
        width: 1200px;
        height: auto;
        margin: 0 auto;
        padding-top: 20px;
    }
    .mid .recharge{
        width: 100%;
        height: auto;
        padding: 20px;
        background-color: #ffffff;
    }
    .mid .recharge .bd-divider{
        font-size: 24px;
        font-weight: 200;
        letter-spacing: 5px;
    }
    .mid .recharge .exclu-list{
        padding: 30px 0;
    }
    .zs_gezi_bg{background: url(../../assets/images/bgzs.jpg) repeat;}
    .exclu-list .exclu-item{
        width: 25%;
        height: 150px;
        color: #fff;
      background:#5b5bd5;
        font-size: 14px;
      text-align: left;
      float:left;

    }
    .exclu-list .exclu-item div{
        display: inline-block;
        padding:20px;
    }

    .exclu-list .exclu-item div.m{
        width: 180px;
        color: #fff;
        font-size: 14px;
        font-weight: 600;
        padding:0px 20px;
        margin-top:20px;
    }
    .exclu-list .exclu-item div.r{
        color: #fff;
        font-size: 14px;
    }
    .exclu-list .btn-box{
        width: 100%;
        height: auto;
        text-align: center;
        padding-top: 20px;
    }
    .footer{
        color: #666666;
        text-align: center;
        line-height: 114px;
    }
    .title2{font-size:24px;text-align: center;}
    .sm2{padding:20px;}
    .sm2 img{float:left;width:670px;}
    .sm2 .sm22{float:right;margin-top:50px;width:400px;}
    .sm2 .title33{font-size:16px;font-weight: bolder;}

    .use-scene .use-scene-list li {
      width: 545px;
      height: 512px;
      color: #1D2843;
      background-image: url(../../assets/images/zs/use-scene-item-bg.png);
      background-repeat: no-repeat;
      background-size: 100%;
      -webkit-box-shadow: 0px 0px 20px rgba(46, 107, 252, 0.08);
      box-shadow: 0px 0px 20px rgba(46, 107, 252, 0.08);
      padding: 38px 0 0;
      float:left;
    }


    .use-scene .use-scene-img {
      display: block;
      height: 307px;
      margin: 0 auto;
    }

    .use-scene .use-scene-item-title {
      line-height: 22px;
      font-size: 20px;
      font-weight: 600;
      text-align: center;
      margin-top: 58px;
    }

    .use-scene .use-scene-item-desc {
      width: 382px;
      line-height: 22px;
      font-size: 16px;
      margin: 10px auto 0;
    }
    .page-enterprise-domain section {
      width: 100%;
    }



    .enterprise-domain-about .section-container {
      padding-top: 47px;
    }

    .enterprise-domain-about .about-desc {
      line-height: 34px;
      font-size: 22px;
      text-align: center;
    }

    .enterprise-domain-about .about-title {
      line-height: 34px;
      font-size: 22px;
      font-weight: 600;
      text-align: center;
      margin-top: 10px;
    }
    .enterprise-domain-about {
      height: 216px;
      color: #1D2843;
      background-color: #e2e9f9;
      background-image: url(../../assets/images/zs/enterprise-domain-about-bg.jpg);
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    }


    .enterprise-domain-about .about-use-btn {
      margin: 23px auto 0;
    }
    section .primary-btn,
    section .plain-btn {
      display: block;
      width: 120px;
      height: 36px;
      line-height: 36px;
      font-size: 14px;
      text-align: center;
      letter-spacing: 1px;
      border-radius: 4px;
    }

    section .primary-btn {
      color: #fff;
      background-color: #4D7EF4;
    }

    section .primary-btn:hover {
      background-color: #249cff;
    ;
    }

    section .plain-btn {
      color: #4D7EF4;
      background-color: #fff;
      border: 1px solid #4D7EF4;
    }

    .section .plain-btn:hover {
      color: #fff;
      background-color: #249cff;
      border-color: #249cff;
    }


    .why-use .section-container {
      padding: 60px 0 70px;
    }

    .why-use .why-use-title {
      line-height: 40px;
      font-size: 28px;
      font-weight: 500;
      text-align: center;
    }

    .why-use .why-use-list {
      margin-top: 33px;
    }

    .why-use .why-use-list li {
      width: 304px;
      height: 242px;
      background-color: #fff;
      border: 1px solid #E9EBF0;
      border-radius: 4px;
      -webkit-box-shadow: 0px 0px 20px rgba(46, 107, 252, 0.08);
      box-shadow: 0px 0px 20px rgba(46, 107, 252, 0.08);
      padding: 28px 32px 0 32px;
      -webkit-transform: translateY(0px);
      transform: translateY(0px);
      -webkit-transition: transform .2s ease-in-out;
      transition: transform .2s ease-in-out;
      float:left;
      margin-left:20px;
    }

    .why-use .why-use-list li:hover {
      -webkit-transform: translateY(-10px);
      transform: translateY(-10px);
    }

    .why-use .why-use-list li img {
      height: 70px;
      display: block;
      margin: 0 auto 17px;
    }

    .why-use .why-use-list li h5 {
      line-height: 25px;
      font-size: 18px;
      font-weight: 600;
      text-align: center;
      margin-bottom: 10px;
    }

    .why-use .why-use-list li p {
      line-height: 20px;
      font-size: 14px;
      color: #585E6C;
    }

    .exs_d1 {display: flex; flex-wrap: wrap;margin-top:50px;font-size:18px;justify-content: space-between}
    .exs_d1 a{width:280px;text-align: left; position: relative;margin-top:10px;padding:10px 5px;border:1px solid #ddd; border-radius: 4px;color:#333;}
    .exs_d1 a:hover{background:#008DF2;color:#fff; border:1px solid #008DF2; }
    .exs_d1 a:hover .tips33{background:#fff !important;color:#008DF2 !important;}
    .exs_d1 a:hover .price{color:#fff !important;}
</style>
